import React from 'react';
import ImageItemMoby from './ImageItemMoby/ImageItemMoby';
import PriceItimMoby from './PriceItimMoby/PriceItimMoby';
import Css from './ProductItemMoby.module.css';
import ProprBlockMiniMoby from './ProprBlockMiniMoby/ProprBlockMiniMoby';
import PropriteBlockMoby from './PropriteBlockMoby/PropriteBlockMoby';
import SaleItemsMoby from './SaleItemsMoby/SaleItemsMoby';
import TitleItemMoby from './TitleItemMoby/TitleItemMoby';


function ProductItemMoby(props) {
  
  return (
    <div className={Css.productItem}>
      <ImageItemMoby  image={props.image} code={props.code} images={props.images}/>
      <PropriteBlockMoby previewText={props.previewText}/>
      <TitleItemMoby title={props.title} idItem={props.idItem} ppid={props.ppid} code={props.code} price={props.price} getCatalogItemsFish={props.getCatalogItemsFish} basketFish={props.basketFish}/>
      <ProprBlockMiniMoby country={props.country} producer={props.producer} />
      <PriceItimMoby price={props.price} saleprice={props.saleprice} fakprice={props.fakprice}/>
      <SaleItemsMoby fakprice={props.fakprice} discont={props.discont} price={props.price} saleprice={props.saleprice} />
    </div>
  );
}

export default ProductItemMoby;